import 'bootstrap/dist/css/bootstrap.css';
import { Route, Switch } from 'react-router-dom';
import './App.scss';
import Demo from './Demo';
import Result from './Result';
function App() {
  return (
    <Switch>
      <Route path='/result/' component={Result} />
      <Route path='/' component={Demo} />
    </Switch>
  );
}

export default App;
